import { paymentOptions } from '../composables/salesPropertyFormOptions';

export const parseSalesTableDate = value => {
  const source = String(value || '').trim();
  if (!source) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(source)) {
    const [year, month, day] = source.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(source)) {
    const [day, month, year] = source.split('/').map(Number);
    return new Date(year, month - 1, day);
  }
  const parsed = new Date(source);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatSalesTableDate = (value, emptyValue) => {
  const date = parseSalesTableDate(value);
  return date
    ? new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' }).format(date)
    : emptyValue;
};

export const salesElapsedDays = (value, now = new Date()) => {
  const signature = parseSalesTableDate(value);
  if (!signature) return null;
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  signature.setHours(0, 0, 0, 0);
  return Math.floor((today.getTime() - signature.getTime()) / 86400000);
};

export const salesElapsedClass = days => {
  if (days === null) return 'text-lais-text-muted';
  if (days > 15) return 'text-lais-danger';
  if (days > 5) return 'text-amber-600';
  return 'text-emerald-600';
};

const correctionIcon = (matching, pending) => {
  if (pending) return 'i-lucide-circle-alert text-amber-600';
  if (matching.length) return 'i-lucide-circle-check text-emerald-600';
  return 'i-lucide-circle-dashed text-lais-text-muted';
};

export const salesCorrectionGroups = (review, t) => {
  const items = Array.isArray(review?.items) ? review.items : [];
  const groups = [
    {
      key: 'property',
      label: t('SALES.TABLE.CORRECTION_PROPERTY'),
      sections: ['imovel'],
    },
    {
      key: 'sellers',
      label: t('SALES.TABLE.CORRECTION_SELLERS'),
      sections: ['vendedor_pf', 'vendedor_pj'],
    },
    {
      key: 'buyers',
      label: t('SALES.TABLE.CORRECTION_BUYERS'),
      sections: ['comprador_pf', 'comprador_pj'],
    },
    {
      key: 'receipt',
      label: t('SALES.TABLE.CORRECTION_RECEIPT'),
      sections: ['recibo'],
    },
  ];
  return groups.map(group => {
    const matching = items.filter(item =>
      group.sections.includes(item.section)
    );
    return {
      key: group.key,
      label: group.label,
      icon: correctionIcon(
        matching,
        matching.some(item => item.status === 'pendente')
      ),
    };
  });
};

export const salesPaymentLabels = (profile, t, emptyValue) => {
  const source = profile?.forma_pagamento;
  const values = Array.isArray(source)
    ? source
    : String(source || '')
        .split(',')
        .map(value => value.trim())
        .filter(Boolean);
  const options = paymentOptions(t);
  return values.length
    ? values
        .map(
          value =>
            options.find(option => option.value === String(value))?.label ||
            value
        )
        .join(', ')
    : emptyValue;
};

export const salesDeadlineState = (postSale, now = Date.now()) => {
  const dueDate = parseSalesTableDate(postSale?.status_due_at);
  if (!dueDate || ['finalizado', 'cancelado'].includes(postSale?.status)) {
    return '';
  }
  const timestamp = now instanceof Date ? now.getTime() : Number(now);
  return dueDate.getTime() < timestamp ? 'overdue' : 'on_time';
};

export const salesDeadlineLabel = (state, t) => {
  if (state === 'overdue') return t('SALES.TABLE.OVERDUE');
  if (state === 'on_time') return t('SALES.TABLE.ON_TIME');
  return '';
};

export const salesReceiptLabel = (profile, t, emptyValue) => {
  if (profile?.recibo_type === 'manual') {
    return t('SALES.TABLE.RECEIPT_MANUAL');
  }
  if (profile?.recibo_type === 'docusign') {
    return t('SALES.TABLE.RECEIPT_DOCUSIGN');
  }
  return emptyValue;
};
